import { Routes } from '@angular/router';
import { MmuMoveBgFrameComponent, MmuRemoteModuleService } from '@move/core';
import {
  UnexpectedNavigationErrorComponent
} from './unexpected-navigation-error/unexpected-navigation-error.component';


export const ROUTES: Routes = [
  /** REMOTE MODULES ------------------------------------------------------------------------------------------------ */
  {
    path: 'user',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'user/Root',
      manifestUrl: 'user/manifest.json',
      moduleFile: 'user.js'
    }).then(m => m['UserModule'])
  },
  {
    path: '4user',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'userSphere/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: '4user/manifest.json', // where the manifest is located
      moduleFile: 'userSphere.js'          // the key within the manifest
    }).then(m => m['UserSphereModule'])   // the module name that will be shown here
  },
  {
    path: 'service',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'service/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'service/manifest.json', // where the manifest is located
      moduleFile: 'service.js'          // the key within the manifest
    }).then(m => m['ServiceModule'])   // the module name that will be shown here
  },
  {
    path: 'support',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'support/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'support/manifest.json', // where the manifest is located
      moduleFile: 'support.js'          // the key within the manifest
    }).then(m => m['SupportModule'])   // the module name that will be shown here
  },
  {
    path: 'actions',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'actions/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'actions/manifest.json', // where the manifest is located
      moduleFile: 'actions.js'          // the key within the manifest
    }).then(m => m['ActionsModule'])   // the module name that will be shown here
  },
  {
    path: 'laundry',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'laundry/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'laundry/manifest.json', // where the manifest is located
      moduleFile: 'laundry.js'          // the key within the manifest
    }).then(m => m['LaundryModule'])   // the module name that will be shown here
  },
  {
    path: 'watson',
    /* ToDo: Update readme on that eager error */
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'watson/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'watson/manifest.json', // where the manifest is located
      moduleFile: 'watson.js'          // the key within the manifest
    }).then(m => m['WatsonModule'])   // the module name which needs to be exposed as a Promise (see README)
  },
  {
    path: 'pages',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'pages/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'pages/manifest.json', // where the manifest is located
      moduleFile: 'pages.js'          // the key within the manifest
    }).then(m => m['PagesModule'])   // the module name which needs to be exposed as a Promise (see README)
  },
  {
    path: 'appwash',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'appwash/Root',  // the remote module name (must be defined by the remote module)
      manifestUrl: 'appwash/manifest.json', // where the manifest is located
      moduleFile: 'appwash.js'          // the key within the manifest
    }).then(m => m['AppWashModule'])   // the module name which needs to be exposed as a Promise (see README)
  },
  /** ERROR ROUTES --------------------------------------------------------------------------------------------------------------*
   *  These routes are used to navigate the error pages directly (e.g. when redirecting after a failed API request)
   */
  {
    path: 'error/navigation',
    component: MmuMoveBgFrameComponent,
    children: [
      {
        path: '',
        data: { title: 'Error' },
        component: UnexpectedNavigationErrorComponent
      }
    ]
  },
  {
    path: 'error',
    component: MmuMoveBgFrameComponent,
    loadChildren: () => import('@move/core').then((m) => m.MmuErrorModule)
  },
  {
    // Appliances vertical is located at the root path
    // Important: This route definition must come last in the array as it is always matched (empty route)!
    path: '',
    loadChildren: () => MmuRemoteModuleService.loadRemoteModule({
      remoteModule: 'appliances/Root',
      manifestUrl: 'manifest.json',
      moduleFile: 'appliances.js'
    }).then(m => m['AppliancesModule'])
  },
  /** WILDCARD (CatchAll) --------------------------------------------------------------------------------------------------------
   * This is required because we want the URL to be kept in the browser (for refresh capability) when no route match was found.
   */
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error'
  }
];
